<div class="site-index-component">
  <h2 class="widget-header h4" i18n="collaboration sites header@@collaboration-sites-header">Your collaboration sites</h2>
  <h3 class="text-muted h6" i18n="collaboration team sites sub header@@collaboration-team-sites-sub-header">In the index below you find the collaboration sites where you are a member or owner. You can select ”View all sites” to see all collaboration sites you have permission to see.</h3>
  <div class="site-index-container">
    <div class="row align-items-center mt-2 mb-2 justify-content-between">
      <div class="col-12 col-lg-4 mt-2">
        <fieldset>
          <legend class="legend" i18n="collaboration sites select scope@@collaboration-sites-select-scope">Select scope</legend>
          <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedMode" role="radiogroup">
            <mat-radio-button [value]="0" class="mr-4" i18n="collaboration sites tab my-site@@collaboration-sites-tab-my-site">View your sites</mat-radio-button>
            <mat-radio-button [value]="1" i18n="collaboration sites tab all-sites@@collaboration-sites-tab-all-sites">View all sites</mat-radio-button>
          </mat-radio-group>
        </fieldset>
      </div>
      <div class="col-12 col-lg-8">
        <div class="row mt-2 justify-content-end">
          <div class="col-auto">
            <form [formGroup]="siteIndexForm" class="site-index-form w-100">
              <mat-form-field appearance="outline" class="site-index-filter-form">
                <mat-label i18n="collaboration sites tab filter@@collaboration-sites-tab-filter">Filter by name</mat-label>
                <input matInput placeholder="Filter by name" i18n-placeholder="collaboration sites tab filter@@collaboration-sites-tab-filter" formControlName="filter">
                <i role="img" alt="Search" class="fa fa-search search-icon" matSuffix></i>
              </mat-form-field>
            </form>
          </div>
          <div class="col-auto site-index-create-site-section">
            <ng-container *ngIf="featureSettingsStoreService.state.redirectCreateGroupButtonToUrl;else createSiteBtn">
              <a mat-flat-button color="accent" *ngIf="allowedToCreateNew$ | async" href="{{ featureSettingsStoreService.state.redirectCreateGroupButtonToUrl }}" class="h-100">
                <span i18n="collab site create new button@@collab-site-create-new-button">New collaboration site</span>
              </a>
            </ng-container>

            <ng-template #createSiteBtn>
              <ng-container *ngIf="!featureSettingsStoreService.state.coreIntranetEnabled">
                <a mat-flat-button color="accent" *ngIf="allowedToCreateNew$ | async" [routerLink]="['/create-site']" class="h-100">
                  <span i18n="collab site create new button@@collab-site-create-new-button">New collaboration site</span>
                </a>
              </ng-container>
              <ng-container *ngIf="featureSettingsStoreService.state.coreIntranetEnabled">
                <a mat-flat-button color="accent" *ngIf="allowedToCreateNew$ | async" [routerLink]="['', { outlets: { modal: 'create-site'}}]" class="h-100">
                  <span i18n="collab site create new button@@collab-site-create-new-button">New collaboration site</span>
                </a>
              </ng-container>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="selectedMode === 0">
      <div class="row mt-4" *ngIf="mySitesGroupedByLetters$ | async as mySitesGroupedByLetters;else loading">
        <div class="col">
          <div *ngFor="let letter of mySitesGroupedByLetters | keyvalue" class="row">
            <div class="col letter-key" id="{{letter.key === '#' ? 'number' : letter.key}}" [attr.data-letter]="letter.key">
              <div class="row">
                <div class="col">
                  <h2 class="bolder">{{letter.key}}</h2>
                </div>
              </div>
              <div class="row">
                <div *ngFor="let site of letter.value" class="col-12 col-lg-6 col-xl-4 col-xxl-3">
                  <div class="pb-4 pr-3">
                    <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--TeamsLogo" *ngIf="site.HasTeam;else noteam"></i>
                    <ng-template #noteam>
                      <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--YammerLogo" *ngIf="site.HasYammer;else noyammer"></i>
                    </ng-template>
                    <ng-template #noyammer>
                      <i aria-hidden="true" class="mr-2 ms-Icon" [ngClass]="site.GroupId ? 'ms-Icon--Group': 'ms-Icon--SharepointLogo'"></i>
                    </ng-template>
                    <ng-container *ngIf="enablePopover">
                      <a href="{{site.Url}}" #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
                        {{site.Title}}
                      </a>
                      <app-popover [originOverlay]="overlayOrigin">
                        <div class="p-4 bg-color border border-color popover-bg site-info-card">
                          <div class="border-bottom border-light-color mb-2">
                            <h2 class="extra-bold site-title">{{site.Title}}</h2>
                            <p>
                              <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--TeamsLogo" *ngIf="site.HasTeam;else noteam"></i>
                              <ng-template #noteam>
                                <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--YammerLogo" *ngIf="site.HasYammer;else noyammer"></i>
                              </ng-template>
                              <ng-template #noyammer>
                                <i aria-hidden="true" class="mr-2 ms-Icon" [ngClass]="site.GroupId ? 'ms-Icon--Group': 'ms-Icon--SharepointLogo'"></i>
                              </ng-template>
                            </p>

                            <p class="text-wrap site-description">{{site.Description}}</p>

                            <p>
                              <span class="pr-2">Go to: </span>
                              <a href="{{site.ConversationUrl}}" componentId="app-site-index">
                                <span class="pr-2">Conversations</span>
                              </a>
                              <a href="{{site.FilesUrl}}" componentId="app-site-index">
                                <span class="pr-2">Files</span>
                              </a>
                              <a href="{{site.CalendarUrl}}" componentId="app-site-index">
                                <span class="pr-2">Calendar</span>
                              </a>
                              <a href="{{site.PlannerUrl}}" componentId="app-site-index">
                                <span class="pr-2">Planner</span>
                              </a>
                              <a href="{{site.SiteUrl}}" componentId="app-site-index'">
                                <span class="pr-2">Site</span>
                              </a>
                              <a *ngIf="site.HasTeam" href="{{site.Url}}" componentId="app-site-index">
                                <span class="pr-2">Team</span>
                              </a>
                            </p>
                          </div>
                          <span class="pt-4">{{site.Visibility}}</span>
                        </div>
                      </app-popover>
                    </ng-container>
                    <ng-container *ngIf="!enablePopover">
                      <a href="{{site.Url}}" title="{{site.Title}}">
                        {{site.Title}}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="mySitesGroupedByLetters && mySitesGroupedByLetters.size === 0">
            <app-text-placeholder>
              <p i18n="@@site-index-no-results">No sites could be found.</p>
            </app-text-placeholder>
          </div>
        </div>
        <div class="d-none d-md-block col-auto">
          <div class="sticky" [appStickyFill]="true">
            <app-table-of-contents [selectors]="'div.letter-key'"></app-table-of-contents>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedMode === 1">
      <div class="row mt-4" *ngIf="allSitesGroupedByLetters$ | async as allSitesGroupedByLetters;else loading">
        <div class="col">
          <div *ngFor="let letter of allSitesGroupedByLetters | keyvalue" class="row">
            <div class="col letter-key" id="{{letter.key === '#' ? 'number' : letter.key}}" [attr.data-letter]="letter.key">
              <div class="row">
                <div class="col">
                  <h2 class="bolder">{{letter.key}}</h2>
                </div>
              </div>
              <div class="row">
                <div *ngFor="let site of letter.value" class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="pb-4 pr-3">
                    <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--TeamsLogo" *ngIf="site.HasTeam;else noteam"></i>
                    <ng-template #noteam>
                      <i aria-hidden="true" class="mr-2 ms-Icon" [ngClass]="site.GroupId ? 'ms-Icon--Group': 'ms-Icon--SharepointLogo'"></i>
                    </ng-template>
                    <ng-container *ngIf="enablePopover">
                      <a href="{{site.Url}}" #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
                        {{site.Title}}
                      </a>
                      <app-popover [originOverlay]="overlayOrigin">
                        <div class="p-4 bg-color border border-color popover-bg site-info-card">
                          <div class="border-bottom border-light-color mb-2">
                            <h2 class="extra-bold site-title">{{site.Title}}</h2>
                            <p>
                              <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--TeamsLogo" *ngIf="site.HasTeam;else noteam"></i>
                              <ng-template #noteam>
                                <i aria-hidden="true" class="mr-2 ms-Icon ms-Icon--YammerLogo" *ngIf="site.HasYammer;else noyammer"></i>
                              </ng-template>
                              <ng-template #noyammer>
                                <i aria-hidden="true" class="mr-2 ms-Icon" [ngClass]="site.GroupId ? 'ms-Icon--Group': 'ms-Icon--SharepointLogo'"></i>
                              </ng-template>
                            </p>

                            <p class="text-wrap site-description">{{site.Description}}</p>

                            <p>
                              <span class="pr-2" i18n="@@go-to">Go to: </span>
                              <a href="{{site.ConversationUrl}}" componentId="app-site-index">
                                <span class="pr-2" i18n="@@conversations">Conversations</span>
                              </a>
                              <a href="{{site.FilesUrl}}" componentId="app-site-index">
                                <span class="pr-2" i18n="@@files">Files</span>
                              </a>
                              <a href="{{site.CalendarUrl}}" componentId="app-site-index">
                                <span class="pr-2" i18n="@@calendar">Calendar</span>
                              </a>
                              <a href="{{site.PlannerUrl}}" componentId="app-site-index">
                                <span class="pr-2">Planner</span>
                              </a>
                              <a href="{{site.SiteUrl}}" componentId="app-site-index">
                                <span class="pr-2">Site</span>
                              </a>
                              <a *ngIf="site.HasTeam" href="{{site.Url}}" componentId="app-site-index">
                                <span class="pr-2">Team</span>
                              </a>
                            </p>
                          </div>
                          <span class="pt-4">{{site.Visibility}}</span>
                        </div>
                      </app-popover>
                    </ng-container>
                    <ng-container *ngIf="!enablePopover">
                      <a href="{{site.Url}}" title="{{site.Title}}">
                        {{site.Title}}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="allSitesGroupedByLetters && allSitesGroupedByLetters.size === 0">
            <app-text-placeholder>
              <p i18n="@@site-index-no-results">No sites could be found.</p>
            </app-text-placeholder>
          </div>
        </div>
        <div class="d-none d-md-block col-auto">
          <div class="sticky" [appStickyFill]="true">
            <app-table-of-contents [selectors]="'div.letter-key'"></app-table-of-contents>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #loading>
      <div class="mt-4" *ngIf="errorSubject$ | async as err; else innerLoading">
        <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
      </div>
      <ng-template #innerLoading>
        <app-widget-placeholder>
        </app-widget-placeholder>
      </ng-template>
    </ng-template>

  </div>
</div>
